import { useEffect, useRef } from "react";

/**
 * Executa `init` apenas quando o modal abre ou quando `sessionKey` muda
 * (ex.: novo cadastro vs. edição de outro registro). Evita reinicializar o
 * formulário em refresh de dados em background (auto-refresh, visibility).
 */
export function useModalFormSession(open: boolean, sessionKey: string, init: () => void): void {
  const activeKeyRef = useRef<string | null>(null);
  const initRef = useRef(init);
  initRef.current = init;

  useEffect(() => {
    if (!open) {
      activeKeyRef.current = null;
      return;
    }
    if (activeKeyRef.current === sessionKey) return;
    activeKeyRef.current = sessionKey;
    initRef.current();
  }, [open, sessionKey]);
}
